// have a type to determine which config to use watch/live/trailer
import { PLAYER_REFERENCE_GLOBAL, VOD, CONTINUOUS, RESTART } from 'helpers/PlayerHelper';
import { tveEnabled, getLastKnownProfileId, getLastAnonymousProfileId } from 'helpers/ConfigHelper';
import { getDynamicImage, WATCH_PLAYER_BACKGROUND_IMAGE } from 'helpers/ImageHelper';
import { getAuthorizingNetwork, VIDEO_TYPE_WATCH, VIDEO_TYPE_TRAILER } from 'helpers/ContentHelper';

const playerId = `video-player-${PLAYER_REFERENCE_GLOBAL}`;

const getVideoConfig = ({ accessToken, anonymousAccount, account, type, video, rest }) => {
  const hash = window.location?.hash;
  const defaultConfig = {
    id: playerId,
    width: '100%',
    height: '100%',
    auth: {
      mvpdId: true,
      profile: {
        profileAnonymous: !account,
        profileId: account?.profileId ?? anonymousAccount?.profileId,
        accessToken,
        lastKnownProfileId: getLastKnownProfileId(),
        lastAnonymousProfileId: getLastAnonymousProfileId(),
      },
      authorizingNetwork: getAuthorizingNetwork(video, false, accessToken),
      networkEntitlementList: 'foxnation',
    },
    image: getDynamicImage({
      url: video?.images?.still?.raw,
      context: WATCH_PLAYER_BACKGROUND_IMAGE,
    }),
    releaseURL: video?.playerScreenUrl,
    tveEnabled: tveEnabled(),
    watch: {
      streamId: video?.id,
      streamType: VOD,
      privacy: {
        lat: false,
      },
    },
    videoID: video?.id,
    mode: VOD,
    type: 'standard',
    percentWatched: 0,
  };

  const watchConfig = {
    authorizingNetwork: getAuthorizingNetwork(video, false, accessToken),
    continuous: hash?.includes(CONTINUOUS),
    creditCuePoint: video?.creditCuePoint,
    mute: false,
    networkEntitlementList: 'foxnation',
    percentwatched: video?.percentwatched, // bookmarks v2
    restart: hash?.includes(RESTART),
  };

  const trailerConfig = {
    ...rest,
  };

  const config = {
    ...defaultConfig,
    ...(type === VIDEO_TYPE_WATCH ? watchConfig : {}),
    ...(type === VIDEO_TYPE_TRAILER ? trailerConfig : {}),
  };

  return config;
};

export default getVideoConfig;
